var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.999 511.999",
    height: "90px",
    viewBox: "0 0 511.999 511.999",
    width: "90px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m472.227 0v31.616c-44.547 58.481-114.523 93.268-188.193 93.268h-214.258v41.417h-60.004v130.945h60.004v41.418h58.695v173.334h108.835v-173.333h46.728c73.671 0 143.646 34.786 188.193 93.267v31.616h30v-463.548zm-432.455 267.247v-70.945h30.004v70.945zm60.004-112.363h166.225v153.781h-166.225zm107.53 327.115h-48.836v-143.334h48.835v143.334zm197.484-144.413c-33.677-17.113-71.053-26.927-108.789-28.646v-154.33c37.736-1.719 75.112-11.534 108.789-28.646 24.858-12.632 47.677-29.253 67.438-48.934v309.49c-19.762-19.681-42.58-36.302-67.438-48.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m123.975 218.387h116.021v30h-116.021z",
    transform: "matrix(.6 -.8 .8 .6 -113.913 239.075)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m129.275 179.678h30v30.002h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m206.502 253.869h30v30.002h-30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.9cc1c0e98ee0f88f043d5a81f2d7a199.svg";
export { ForwardRef as ReactComponent };